import { defineMessages } from 'react-intl-next';

export default defineMessages({
    helpDeskDeleteSectionTitle: {
        defaultMessage: 'Delete this team',
        description: 'Delete help desk section title',
        id: 'uh.help.desk.delete.section.title',
    },
    helpDeskDeleteSectionDescription: {
        defaultMessage:
            'Deleting your team will permanently remove it from Unified Help. All associated team resources will also be removed.',
        description: 'Delete help desk section description',
        id: 'uh.help.desk.delete.section.description',
    },
    helpDeskDeleteDialogTitle: {
        defaultMessage: 'You’re about to delete this team',
        description: 'Delete help desk warning dialog title',
        id: 'uh.help.desk.delete.dialog.title',
    },
    helpDeskDeleteDialogDescription: {
        defaultMessage: 'This will remove all details and resources related to the team. This change cannot be undone.',
        description: 'Delete help desk warning dialog description',
        id: 'uh.help.desk.delete.dialog.description',
    },
    helpDeskDeleteDialogConfirmButton: {
        defaultMessage: 'Delete team',
        description: 'Delete help desk warning dialog confirm button',
        id: 'uh.help.desk.delete.dialog.confirm.button',
    },
    helpDeskDeleteDialogCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Delete help desk warning dialog cancel button',
        id: 'uh.help.desk.delete.dialog.cancel.button',
    },
    helpDeskDeleteButton: {
        defaultMessage: 'Delete',
        description: 'Delete button',
        id: 'uh.help.desk.delete.button.text',
    },
    helpDeskDeleteSuccessTitle: {
        defaultMessage: `{value} and its related resources were successfully deleted from Unified Help.`,
        description: 'Title message for delete help desk success',
        id: 'uh.help.desk.delete.success.title',
    },

    helpDeskDeleteFailureTitle: {
        defaultMessage: 'We couldn’t delete {value} from Unified Help.',
        description: 'Title message for delete help desk error',
        id: 'uh.help.desk.delete.failure.title',
    },
    helpDeskDeleteFailureDesc: {
        defaultMessage: 'Wait a moment and then try again.',
        description: 'Description message for delete help desk error',
        id: 'uh.help.desk.delete.failure.desc',
    },
});
